import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function MomSysMaterialError ( props ) {

    return (

        <BasicCrudScreenType
            id="MomSysZvwMaterialErrorSgtWipLot"
            view="MomSysZvwMaterialErrorSgtWipLot"
            onInitialized = {(grid) => grid.selectionMode = "None"}
        />

    )

}

export default MomSysMaterialError;
